import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { compareSemesters } from "../../util";
import { setMessage } from "../slices/message";
import { setHiringSeasons } from "../slices/hiring";
import { BASE_URL } from "./common";

// Define a service using a base URL and expected endpoints
export const hiringApi = createApi({
  reducerPath: "hiringApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),
  endpoints: (builder) => ({
    getAllHiringSeasons: builder.query({
      query: () => ({
        url: `/api/hiring/seasons`,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) =>
        response.data.sort((s1, s2) => compareSemesters(s1, s2)),
      async onQueryStarted(undefined, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setHiringSeasons(data));
        } catch (err) {
          const msg =
            (err && err.error && err.error.data && err.error.data.message) ||
            "An error has occurred when fetching the hiring seasons!";
          dispatch(
            setMessage({ text: msg, error: JSON.stringify(err, null, 2) })
          );
        }
      },
    }),
  }),
});

export const { useGetAllHiringSeasonsQuery } = hiringApi;
